module.exports = __webpack_public_path__ + "img/icon-killer@3x.24ff0895.png";